var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    clipPath: "url(#clip0_1106_347194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1",
    filter: "url(#filter0_d_1106_347194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1106_347194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 52,
    height: 52
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.9524 30.2857C52.9524 44.381 41.5238 55.8095 27.4286 55.8095C13.3334 55.8095 1.90479 44.381 1.90479 30.2857C1.90479 16.1905 13.3334 4.7619 27.4286 4.7619C41.5238 4.7619 52.9524 16.1905 52.9524 30.2857Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1106_347194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.7623 1.14285H-23.9044V60.7619H78.7623V1.14285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.66704 60.7619L-1.04724 50.8571H10.2861L4.66704 60.7619L-1.04724 50.8571H10.2861L4.66704 60.7619Z",
    fill: "url(#paint0_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.66704 50.8571L-1.04724 40.8571H10.2861L4.66704 50.8571L-1.04724 40.8571H10.2861L4.66704 50.8571Z",
    fill: "url(#paint1_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.66704 40.8571L-1.04724 30.9524H10.2861L4.66704 40.8571L-1.04724 30.9524H10.2861L4.66704 40.8571Z",
    fill: "url(#paint2_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.66704 30.9524L-1.04724 20.9524H10.2861L4.66704 30.9524L-1.04724 20.9524H10.2861L4.66704 30.9524Z",
    fill: "url(#paint3_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.66704 20.9524L-1.04724 10.9524H10.2861L4.66704 20.9524L-1.04724 10.9524H10.2861L4.66704 20.9524Z",
    fill: "url(#paint4_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.66704 10.9524L-1.04724 1.04761H10.2861L4.66704 10.9524L-1.04724 1.04761H10.2861L4.66704 10.9524Z",
    fill: "url(#paint5_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.0008 60.7619L10.2865 50.8571H21.7151L16.0008 60.7619L10.2865 50.8571H21.7151L16.0008 60.7619Z",
    fill: "url(#paint6_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.0008 50.8571L10.2865 40.8571H21.7151L16.0008 50.8571L10.2865 40.8571H21.7151L16.0008 50.8571Z",
    fill: "url(#paint7_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.0008 40.8571L10.2865 30.9524H21.7151L16.0008 40.8571L10.2865 30.9524H21.7151L16.0008 40.8571Z",
    fill: "url(#paint8_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16.0008 30.9524L10.2865 20.9524H21.7151L16.0008 30.9524L10.2865 20.9524H21.7151L16.0008 30.9524Z",
    fill: "url(#paint9_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.0008 20.9524L10.2865 10.9524H21.7151L16.0008 20.9524L10.2865 10.9524H21.7151L16.0008 20.9524Z",
    fill: "url(#paint10_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M16.0008 10.9524L10.2865 1.04761H21.7151L16.0008 10.9524L10.2865 1.04761H21.7151L16.0008 10.9524Z",
    fill: "url(#paint11_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M27.4294 60.7619L21.7151 50.8571H33.1437L27.4294 60.7619L21.7151 50.8571H33.1437L27.4294 60.7619Z",
    fill: "url(#paint12_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M27.4294 50.8571L21.7151 40.8571H33.1437L27.4294 50.8571L21.7151 40.8571H33.1437L27.4294 50.8571Z",
    fill: "url(#paint13_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M27.4294 40.8571L21.7151 30.9524H33.1437L27.4294 40.8571L21.7151 30.9524H33.1437L27.4294 40.8571Z",
    fill: "url(#paint14_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M27.4294 30.9524L21.7151 20.9524H33.1437L27.4294 30.9524L21.7151 20.9524H33.1437L27.4294 30.9524Z",
    fill: "url(#paint15_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.4294 20.9524L21.7151 10.9524H33.1437L27.4294 20.9524L21.7151 10.9524H33.1437L27.4294 20.9524Z",
    fill: "url(#paint16_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M27.4294 10.9524L21.7151 1.04761H33.1437L27.4294 10.9524L21.7151 1.04761H33.1437L27.4294 10.9524Z",
    fill: "url(#paint17_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M38.8579 60.7619L33.1436 50.8571H44.5722L38.8579 60.7619L33.1436 50.8571H44.5722L38.8579 60.7619Z",
    fill: "url(#paint18_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M38.8579 50.8571L33.1436 40.8571H44.5722L38.8579 50.8571L33.1436 40.8571H44.5722L38.8579 50.8571Z",
    fill: "url(#paint19_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M38.8579 40.8571L33.1436 30.9524H44.5722L38.8579 40.8571L33.1436 30.9524H44.5722L38.8579 40.8571Z",
    fill: "url(#paint20_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M38.8579 30.9524L33.1436 20.9524H44.5722L38.8579 30.9524L33.1436 20.9524H44.5722L38.8579 30.9524Z",
    fill: "url(#paint21_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M38.8579 20.9524L33.1436 10.9524H44.5722L38.8579 20.9524L33.1436 10.9524H44.5722L38.8579 20.9524Z",
    fill: "url(#paint22_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M38.8579 10.9524L33.1436 1.04761H44.5722L38.8579 10.9524L33.1436 1.04761H44.5722L38.8579 10.9524Z",
    fill: "url(#paint23_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M50.2865 60.7619L44.5722 50.8571H56.0008L50.2865 60.7619L44.5722 50.8571H56.0008L50.2865 60.7619Z",
    fill: "url(#paint24_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M50.2865 50.8571L44.5722 40.8571H56.0008L50.2865 50.8571L44.5722 40.8571H56.0008L50.2865 50.8571Z",
    fill: "url(#paint25_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M50.2865 40.8571L44.5722 30.9524H56.0008L50.2865 40.8571L44.5722 30.9524H56.0008L50.2865 40.8571Z",
    fill: "url(#paint26_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M50.2865 30.9524L44.5722 20.9524H56.0008L50.2865 30.9524L44.5722 20.9524H56.0008L50.2865 30.9524Z",
    fill: "url(#paint27_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M50.2865 20.9524L44.5722 10.9524H56.0008L50.2865 20.9524L44.5722 10.9524H56.0008L50.2865 20.9524Z",
    fill: "url(#paint28_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M50.2865 10.9524L44.5722 1.04761H56.0008L50.2865 10.9524L44.5722 1.04761H56.0008L50.2865 10.9524Z",
    fill: "url(#paint29_linear_1106_347194)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M50.2865 1.04761L56.0008 11.0476H44.5722L50.2865 1.04761L56.0008 11.0476H44.5722L50.2865 1.04761Z",
    fill: "url(#paint30_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M50.2865 11.0476L56.0008 20.9524H44.5722L50.2865 11.0476L56.0008 20.9524H44.5722L50.2865 11.0476Z",
    fill: "url(#paint31_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M50.2865 20.9524L56.0008 30.9524H44.5722L50.2865 20.9524L56.0008 30.9524H44.5722L50.2865 20.9524Z",
    fill: "url(#paint32_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M50.2865 30.9524L56.0008 40.8571H44.5722L50.2865 30.9524L56.0008 40.8571H44.5722L50.2865 30.9524Z",
    fill: "url(#paint33_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M50.2865 40.8571L56.0008 50.8571H44.5722L50.2865 40.8571L56.0008 50.8571H44.5722L50.2865 40.8571Z",
    fill: "url(#paint34_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M50.2865 50.8571L56.0008 60.7619H44.5722L50.2865 50.8571L56.0008 60.7619H44.5722L50.2865 50.8571Z",
    fill: "url(#paint35_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M38.8579 1.04761L44.5722 11.0476H33.1436L38.8579 1.04761L44.5722 11.0476H33.1436L38.8579 1.04761Z",
    fill: "url(#paint36_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M38.8579 11.0476L44.5722 20.9524H33.1436L38.8579 11.0476L44.5722 20.9524H33.1436L38.8579 11.0476Z",
    fill: "url(#paint37_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M38.8579 20.9524L44.5722 30.9524H33.1436L38.8579 20.9524L44.5722 30.9524H33.1436L38.8579 20.9524Z",
    fill: "url(#paint38_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M38.8579 30.9524L44.5722 40.8571H33.1436L38.8579 30.9524L44.5722 40.8571H33.1436L38.8579 30.9524Z",
    fill: "url(#paint39_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M38.8579 40.8571L44.5722 50.8571H33.1436L38.8579 40.8571L44.5722 50.8571H33.1436L38.8579 40.8571Z",
    fill: "url(#paint40_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M38.8579 50.8571L44.5722 60.7619H33.1436L38.8579 50.8571L44.5722 60.7619H33.1436L38.8579 50.8571Z",
    fill: "url(#paint41_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M27.4294 1.04761L33.1437 11.0476H21.7151L27.4294 1.04761L33.1437 11.0476H21.7151L27.4294 1.04761Z",
    fill: "url(#paint42_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M27.4294 11.0476L33.1437 20.9524H21.7151L27.4294 11.0476L33.1437 20.9524H21.7151L27.4294 11.0476Z",
    fill: "url(#paint43_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M27.4294 20.9524L33.1437 30.9524H21.7151L27.4294 20.9524L33.1437 30.9524H21.7151L27.4294 20.9524Z",
    fill: "url(#paint44_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M27.4294 30.9524L33.1437 40.8571H21.7151L27.4294 30.9524L33.1437 40.8571H21.7151L27.4294 30.9524Z",
    fill: "url(#paint45_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M27.4294 40.8571L33.1437 50.8571H21.7151L27.4294 40.8571L33.1437 50.8571H21.7151L27.4294 40.8571Z",
    fill: "url(#paint46_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M27.4294 50.8571L33.1437 60.7619H21.7151L27.4294 50.8571L33.1437 60.7619H21.7151L27.4294 50.8571Z",
    fill: "url(#paint47_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M16.0008 1.04761L21.7151 11.0476H10.2865L16.0008 1.04761L21.7151 11.0476H10.2865L16.0008 1.04761Z",
    fill: "url(#paint48_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M16.0008 11.0476L21.7151 20.9524H10.2865L16.0008 11.0476L21.7151 20.9524H10.2865L16.0008 11.0476Z",
    fill: "url(#paint49_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M16.0008 20.9524L21.7151 30.9524H10.2865L16.0008 20.9524L21.7151 30.9524H10.2865L16.0008 20.9524Z",
    fill: "url(#paint50_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M16.0008 30.9524L21.7151 40.8571H10.2865L16.0008 30.9524L21.7151 40.8571H10.2865L16.0008 30.9524Z",
    fill: "url(#paint51_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M16.0008 40.8571L21.7151 50.8571H10.2865L16.0008 40.8571L21.7151 50.8571H10.2865L16.0008 40.8571Z",
    fill: "url(#paint52_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M16.0008 50.8571L21.7151 60.7619H10.2865L16.0008 50.8571L21.7151 60.7619H10.2865L16.0008 50.8571Z",
    fill: "url(#paint53_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M4.66704 1.04761L10.2861 11.0476H-1.04724L4.66704 1.04761L10.2861 11.0476H-1.04724L4.66704 1.04761Z",
    fill: "url(#paint54_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M4.66704 11.0476L10.2861 20.9524H-1.04724L4.66704 11.0476L10.2861 20.9524H-1.04724L4.66704 11.0476Z",
    fill: "url(#paint55_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M4.66704 20.9524L10.2861 30.9524H-1.04724L4.66704 20.9524L10.2861 30.9524H-1.04724L4.66704 20.9524Z",
    fill: "url(#paint56_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M4.66704 30.9524L10.2861 40.8571H-1.04724L4.66704 30.9524L10.2861 40.8571H-1.04724L4.66704 30.9524Z",
    fill: "url(#paint57_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M4.66704 40.8571L10.2861 50.8571H-1.04724L4.66704 40.8571L10.2861 50.8571H-1.04724L4.66704 40.8571Z",
    fill: "url(#paint58_linear_1106_347194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M4.66704 50.8571L10.2861 60.7619H-1.04724L4.66704 50.8571L10.2861 60.7619H-1.04724L4.66704 50.8571Z",
    fill: "url(#paint59_linear_1106_347194)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M78.7623 1.14285H-23.9044V60.7619H78.7623V1.14285Z",
    fill: "url(#paint60_radial_1106_347194)"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M15.7147 23.6191L12.7623 17.7143H18.5719L21.5242 23.6191H15.7147Z",
    fill: "url(#paint61_linear_1106_347194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M27.4286 47.0476L18.5715 29.4286H24.4762L27.4286 35.3334L30.381 29.4286H36.1905L27.4286 47.0476Z",
    fill: "url(#paint62_linear_1106_347194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M33.3334 23.6191L36.1905 17.7143H42.0953L39.1429 23.6191H33.3334Z",
    fill: "url(#paint63_linear_1106_347194)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1106_347194",
    x: -2.09521,
    y: 4.7619,
    width: 59.0476,
    height: 59.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_347194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1106_347194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_347194",
    x1: 10.3329,
    y1: 55.7873,
    x2: -1.07924,
    y2: 55.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1106_347194",
    x1: 10.3329,
    y1: 45.8345,
    x2: -1.07924,
    y2: 45.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1106_347194",
    x1: 10.3329,
    y1: 35.8819,
    x2: -1.07924,
    y2: 35.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1106_347194",
    x1: 10.3329,
    y1: 25.9291,
    x2: -1.07924,
    y2: 25.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1106_347194",
    x1: 10.3329,
    y1: 15.9764,
    x2: -1.07924,
    y2: 15.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1106_347194",
    x1: 10.3329,
    y1: 6.0238,
    x2: -1.07924,
    y2: 6.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1106_347194",
    x1: 21.7455,
    y1: 55.7873,
    x2: 10.3334,
    y2: 55.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1106_347194",
    x1: 21.7455,
    y1: 45.8345,
    x2: 10.3334,
    y2: 45.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1106_347194",
    x1: 21.7455,
    y1: 35.8819,
    x2: 10.3334,
    y2: 35.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1106_347194",
    x1: 21.7455,
    y1: 25.9291,
    x2: 10.3334,
    y2: 25.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1106_347194",
    x1: 21.7455,
    y1: 15.9764,
    x2: 10.3334,
    y2: 15.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1106_347194",
    x1: 21.7455,
    y1: 6.0238,
    x2: 10.3334,
    y2: 6.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1106_347194",
    x1: 33.158,
    y1: 55.7873,
    x2: 21.7456,
    y2: 55.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1106_347194",
    x1: 33.158,
    y1: 45.8345,
    x2: 21.7456,
    y2: 45.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1106_347194",
    x1: 33.158,
    y1: 35.8819,
    x2: 21.7456,
    y2: 35.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1106_347194",
    x1: 33.158,
    y1: 25.9291,
    x2: 21.7456,
    y2: 25.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1106_347194",
    x1: 33.158,
    y1: 15.9764,
    x2: 21.7456,
    y2: 15.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1106_347194",
    x1: 33.158,
    y1: 6.0238,
    x2: 21.7456,
    y2: 6.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1106_347194",
    x1: 44.5702,
    y1: 55.7873,
    x2: 33.158,
    y2: 55.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1106_347194",
    x1: 44.5702,
    y1: 45.8345,
    x2: 33.158,
    y2: 45.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1106_347194",
    x1: 44.5702,
    y1: 35.8819,
    x2: 33.158,
    y2: 35.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1106_347194",
    x1: 44.5702,
    y1: 25.9291,
    x2: 33.158,
    y2: 25.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1106_347194",
    x1: 44.5702,
    y1: 15.9764,
    x2: 33.158,
    y2: 15.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1106_347194",
    x1: 44.5702,
    y1: 6.0238,
    x2: 33.158,
    y2: 6.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1106_347194",
    x1: 55.9829,
    y1: 55.7873,
    x2: 44.5702,
    y2: 55.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1106_347194",
    x1: 55.9829,
    y1: 45.8345,
    x2: 44.5702,
    y2: 45.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1106_347194",
    x1: 55.9829,
    y1: 35.8819,
    x2: 44.5702,
    y2: 35.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1106_347194",
    x1: 55.9829,
    y1: 25.9291,
    x2: 44.5702,
    y2: 25.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1106_347194",
    x1: 55.9829,
    y1: 15.9764,
    x2: 44.5702,
    y2: 15.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1106_347194",
    x1: 55.9829,
    y1: 6.0238,
    x2: 44.5702,
    y2: 6.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1106_347194",
    x1: 55.9825,
    y1: 6.02408,
    x2: 44.5702,
    y2: 6.02408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1106_347194",
    x1: 55.9825,
    y1: 15.9768,
    x2: 44.5702,
    y2: 15.9768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1106_347194",
    x1: 55.9825,
    y1: 25.9292,
    x2: 44.5702,
    y2: 25.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1106_347194",
    x1: 55.9825,
    y1: 35.882,
    x2: 44.5702,
    y2: 35.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1106_347194",
    x1: 55.9825,
    y1: 45.835,
    x2: 44.5702,
    y2: 45.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1106_347194",
    x1: 55.9825,
    y1: 55.7876,
    x2: 44.5702,
    y2: 55.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1106_347194",
    x1: 44.5702,
    y1: 6.02408,
    x2: 33.158,
    y2: 6.02408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1106_347194",
    x1: 44.5702,
    y1: 15.9767,
    x2: 33.158,
    y2: 15.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1106_347194",
    x1: 44.5702,
    y1: 25.9292,
    x2: 33.158,
    y2: 25.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1106_347194",
    x1: 44.5702,
    y1: 35.882,
    x2: 33.158,
    y2: 35.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1106_347194",
    x1: 44.5702,
    y1: 45.835,
    x2: 33.158,
    y2: 45.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1106_347194",
    x1: 44.5702,
    y1: 55.7876,
    x2: 33.158,
    y2: 55.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1106_347194",
    x1: 33.158,
    y1: 6.02408,
    x2: 21.7456,
    y2: 6.02408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1106_347194",
    x1: 33.158,
    y1: 15.9768,
    x2: 21.7456,
    y2: 15.9768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1106_347194",
    x1: 33.158,
    y1: 25.9292,
    x2: 21.7456,
    y2: 25.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1106_347194",
    x1: 33.158,
    y1: 35.882,
    x2: 21.7456,
    y2: 35.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1106_347194",
    x1: 33.158,
    y1: 45.835,
    x2: 21.7456,
    y2: 45.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1106_347194",
    x1: 33.158,
    y1: 55.7876,
    x2: 21.7456,
    y2: 55.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1106_347194",
    x1: 21.7455,
    y1: 6.02408,
    x2: 10.3332,
    y2: 6.02408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1106_347194",
    x1: 21.7455,
    y1: 15.9767,
    x2: 10.3332,
    y2: 15.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1106_347194",
    x1: 21.7455,
    y1: 25.9292,
    x2: 10.3332,
    y2: 25.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1106_347194",
    x1: 21.7455,
    y1: 35.882,
    x2: 10.3332,
    y2: 35.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1106_347194",
    x1: 21.7455,
    y1: 45.835,
    x2: 10.3332,
    y2: 45.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1106_347194",
    x1: 21.7455,
    y1: 55.7876,
    x2: 10.3332,
    y2: 55.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1106_347194",
    x1: 10.3328,
    y1: 6.02408,
    x2: -1.07924,
    y2: 6.02408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1106_347194",
    x1: 10.3328,
    y1: 15.9767,
    x2: -1.07924,
    y2: 15.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1106_347194",
    x1: 10.3328,
    y1: 25.9292,
    x2: -1.07924,
    y2: 25.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1106_347194",
    x1: 10.3328,
    y1: 35.882,
    x2: -1.07924,
    y2: 35.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1106_347194",
    x1: 10.3328,
    y1: 45.835,
    x2: -1.07924,
    y2: 45.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1106_347194",
    x1: 10.3328,
    y1: 55.7876,
    x2: -1.07924,
    y2: 55.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1106_347194",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4506 30.9061) scale(49.8777 27.3796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1106_347194",
    x1: 12.7401,
    y1: 20.6501,
    x2: 21.5487,
    y2: 20.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1106_347194",
    x1: 18.6121,
    y1: 38.2672,
    x2: 36.2292,
    y2: 38.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1106_347194",
    x1: 33.293,
    y1: 20.6501,
    x2: 42.1015,
    y2: 20.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656564"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_347194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.2857,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3823ead1c59e529ac23292d727859506.svg";
export { ForwardRef as ReactComponent };